import React from 'react';

import {InlineFormattedNumber} from '/component/base/FormattedNumber';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import {Cards} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import {
  CoachesTeamSummaryCardItemProps,
  ItemProps,
} from './CoachesTeamSummaryCardItem.types';
import {getStyles, shouldShow} from './CoachesTeamSummaryCardItem.util';

const defaultItem: ItemProps = {
  isFirstItem: false,
  isBusinessLeaderMetric: false,
  text: '',
  testID: undefined,
  value: 0,
  titleTestID: undefined,
};
export const CoachesTeamSummaryCardItem = ({
  item = defaultItem,
  isBusinessLeader,
}: CoachesTeamSummaryCardItemProps) => {
  const {
    isFirstItem,
    isBusinessLeaderMetric,
    text,
    value,
    testID,
    titleTestID,
  } = item;
  const showItem = shouldShow({isBusinessLeaderMetric, isBusinessLeader});

  return showItem ? (
    <ListItem
      {...testProperties(Cards.cardListItem, true)}
      label={
        <Text
          emphasis="standard"
          allowFontScaling
          maxFontSizeMultiplier={2}
          testID={titleTestID}>
          {text}
        </Text>
      }
      readonly
      suffix={<InlineFormattedNumber testID={testID} value={value} />}
      style={{base: getStyles({isFirstItem})}}
    />
  ) : null;
};
